import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
const state = {
  Instagram: {
    'Id': 0,
    'PageTitle': '',
    'InstagramId': '',
    'SubscriptionModuleActivation_Id': 0,
    'HeaderElements': '',
    'FooterElements': ''
  }
}
const getters = {
  Instagram: state => state.Instagram
}
const mutations = {
  [mutationNames.SET_INSTAGRAM] (state, Parent) {
    state.Instagram = Parent
  },
  [mutationNames.UPDATE_INSTAGRAM] (state, obj) {
    Object.assign(state.Instagram, obj)
  }
}
const actions = {
  updatInstagramSettings ({ commit, getters }, payload) {
    commit(mutationNames.UPDATE_INSTAGRAM, payload)
  },
  async getInstagramInfo ({ commit, getters }, SubscriptionModuleId) {
    const response = await api.AppModules.GetInstagramInfo(SubscriptionModuleId)
    commit(mutationNames.SET_INSTAGRAM, response[0])
    return response
  },
  async saveInstagramSettings ({ dispatch, getters }) {
    let InstagramClone = Object.assign({}, getters.Instagram)
    await api.AppModules.SaveInstagramInfo(InstagramClone)
  },
  async UrlValidChk ({ commit, getters }, WebsiteUrl) {
    const response = await api.AppModules.WebsiteUrlValid(WebsiteUrl)
    return response
  },
  async InstagramcaptureScreen ({ commit, getters }, payload) {
    return api.screenShot.capture(payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/instagram.js